import { FC } from 'react';
import { SkeletonWrapper } from './skeleton.styled';
import { SkeletonProps } from './types';

export const Skeleton: FC<SkeletonProps> = (props) => {
  return <SkeletonWrapper {...props} />;
};
